import MobileEventCard from "../mobile/MobileEventCard";
import { useActiveSlide } from '../../ActiveSlideProvider';

export default function MobileEventCardCarousel({ events }) {
    const {activeSlide, setActiveSlide} = useActiveSlide();
    const isActive = "carousel-item active";
    const nActive = "carousel-item";

    const onNext = () => {
        if (activeSlide+1 < events.length) {
            setActiveSlide(activeSlide+1);
        } else {
            setActiveSlide(0);
        }
    };

    const onPrev = () => {
        if (activeSlide-1 < 0) {
            setActiveSlide(events.length-1);
        } else {
            setActiveSlide(activeSlide-1);
        }
    };

    return (
        <div id="eventCardCarousel" className="carousel slide">
            <div className="carousel-inner">
                    {events.map((event, i) => {
                        return (
                        <div className={i===0 ? isActive:nActive} key={event.id}>
                            <MobileEventCard key={event.id} name={event.name} dateTime={event.start_time} categories={event.categories} venue={event.venues[0]} event={event}/>
                        </div>)})}
                <button className="carousel-control-prev" type="button" data-bs-target="#eventCardCarousel" data-bs-slide="prev" onClick={onPrev}>
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#eventCardCarousel" data-bs-slide="next" onClick={onNext}>
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    )
}
  
